import React from 'react';
import { Steps } from 'antd';
import progressDescription from './progressDescription';
// import './FormProgress.css';

const { Step } = Steps;

const FormProgress = ({ progress }) => {
  return (
    <div className="b-sidebar-progress">
      <div className="b-sidebar-progress__title">Прогресс заполнения</div>
      <div className="b-sidebar-progress__list">
        <Steps direction="vertical" size="small" current={1}>
          {progress.map((item, index) => {
            return (
              <Step
                key={index}
                title={item.title}
                description={item.completed && progressDescription(item)}
                status={
                    item && item.name === 'main' ?
                        item.completed ? 'finish' : 'process' :
                        progress && progress[0].completed ? 
                            item.completed ? 'finish' : 'process' : 'wait'
                }
              />
            );
          })}
        </Steps>
      </div>
    </div>
  );
};

export default FormProgress;
